import React from "react";
import "./Schedule.scss";
import FadeInSection from "./FadeInSection";
import RingsIcon from "./images/rings.webp";

function History() {
  return (
    <div className="bg-base">
      <div className="timeline p-top-8 p-bottom-8">
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h4 className="text-primary h4 font-body font-weight-700">
                20 март, 1997г.
              </h4>
              <h4 className="m-bottom-1 m-top-1">Роди се Стоян</h4>
              <p className="m-bottom-1">
                <strong>виновници:</strong> сем. Кръстеви
              </p>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
          <div className="content shadow-default">
              <h4 className="text-primary h4 font-body font-weight-700">
              23 август, 1998г.
              </h4>
              <h4 className="m-bottom-1 m-top-1"> Роди се Инна</h4>
              <p className="m-bottom-1">
                <strong>виновници:</strong> сем. Тончеви
              </p>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left">
          <div className="content shadow-default">
              <h4 className="text-primary h4 font-body font-weight-700">
              01 Юли, 2022г.
              </h4>
              <h4 className="m-bottom-1 m-top-1">
                Запознанство
                <i className="fa-solid fa-heart m-left-2 text-xl"></i>
              </h4>
              <p className="m-bottom-1">
                <strong>виновници:</strong> Габи и Данчо
              </p>
              <p className="m-bottom-1">
                <strong>място:</strong> в колата "Ачко"
              </p>
              <p className="m-bottom-1">
                Всичко започна в легендарното "Ачко" на Данчо, където уж просто излезнахме с приятели, а лятото ни изненада и превърна историята в любов… и то съвсем истинска :)
              </p>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
          <div className="content shadow-default">
              <h4 className="text-primary h4 font-body font-weight-700">
                Февруари, 2025г.
              </h4>
              <h4 className="m-bottom-1 m-top-1 flex flex-align-center">
                <span>Тя каза "ДА"!</span>
              
                <div className="flex flex-align-center">
                  <img
                    alt=""
                    src={RingsIcon}
                    style={{ width: 30 }}
                    className="m-left-2"
                  />
                </div>
              </h4>
              <p className="m-bottom-1">
                <strong>място:</strong> пред Катедралата в гр. Варна
              </p>
              <p className="m-bottom-1">
              След дълго умуване, с пръстен закупен още от 2024г., в една студена нощ през февруари, разхождайки се по центъра на гр. Варна, Стоян събира смелост и решава, че сега е перфектният момент да падне на колене пред Инна... и го прави...</p>
              <p className="m-bottom-1 m-top-1">
                <strong className="text-primary">Tя:</strong> (силен писък и замръзване) ...
              </p>
              <p className="m-bottom-1">
                <strong>Tой:</strong> Ще станеш ли моя ЖЕНА, ей тук, пред Катедралата те питам... пред Господ!
              </p>
              <p className="m-bottom-1">
                <strong className="text-primary">Tя (онемяла):</strong> ... д дд... ДА!
              </p>
              <p className="m-bottom-1">
                <strong>Приятелите:</strong> Горчиво! Горчиво! Горчиво!
              </p>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left">
          <div className="content shadow-default">
              <h4 className="text-primary h4 font-body font-weight-700">
              06 Юни, 2026г.
              </h4>
              <h4 className="m-bottom-1 m-top-1">
                Сватба - сем. Стоянови
                <i className="fa-brands fa-fort-awesome m-left-1 text-xl" />
              </h4>
              <p className="m-bottom-1">
                <strong>Място:</strong> с. Аспарухово
              </p>
              <p className="m-bottom-1">
              Родителите на Булката са сключили брак на 08.08, Кумовете ни са ожениха на 07.07, а сега е наш ред да го направим на 06.06!
              Ще бъде щастие да сте до нас в този важен ден!
              </p>
            </div>
          </div>
        </FadeInSection>
      </div>
    </div>
  );
}

export default History;
